import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {getPrefilledGateData,saveRenewalRequest,getPrefilledRequestData,getGateBasePrices} from "services/redux/contractRenewal/action";
import RaiseRenewalRequest from "./raiseRenewalRequest";
const mapStateToProps = (state) => ({
  prefilledGateData: state.contractRenewalReducer.prefilledGateData,
  renewalRequest: state.contractRenewalReducer.renewalRequest,
  prefilledRequestData: state.contractRenewalReducer.prefilledRequestData,
  basePrices:state.contractRenewalReducer.basePrices
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPrefilledGateData,
      saveRenewalRequest,
      getPrefilledRequestData,
      getGateBasePrices
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RaiseRenewalRequest);
